import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions,getSessionCredentials } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import Feedback from './Feedback';
import { Select } from '@mui/material';



export const LogicManagerFeedbacksRoute = () => {
    const token = getSessionCredentials()?.token ?? '';
    const [content, setContent] = useState<string>(""); // Inicialize como null
    const navigate = useNavigate()
    const [user,setUserAuth] = useState<any>(null)
    const [feedbacks,setFeedbacks] = useState<any>(null)
    const [feedbackType,setFeedbackType] = useState<string>('2')
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
        }
    }
    useEffect(() => {
        fetchFeedbacks();

    }, []);



    const fetchFeedbacks = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/feedbacks`,requestConfig);
        setFeedbacks(response.data);
        console.log(response.data)
    };

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.admin'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);
    const sendForm  =async (formData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/feedback`, formData,requestConfig);
            fetchFeedbacks()
        } catch (error: any) {
            if (error.response && error.response.status === 422) {
                alert('Erro de validação: ' + JSON.stringify(error.response.data.errors));
            } else {
                alert('Erro ao adicionar membro: ' + error.message);
            }
        }
    }

    const adicionarFeedback = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('message', content);
        formData.append('FK_feedback_type_id',feedbackType)
        sendForm(formData)
    
    
       
    };

    const deletarFeedback = async (id) => {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/feedback/${id}`,requestConfig);
        setFeedbacks(feedbacks.filter((membro) => membro.id !== id));
    };



    const goBackwards = () => {     
        navigate('/manager');       
};

    return (

<div className={styles.wrapper}>
<Board wrapperClass={styles.board}>

        <div className={styles.container}>
            <h1 className={styles.titulo}>Feedbacks</h1>
            <form onSubmit={adicionarFeedback} className="form">
                <input
                    type="text"
                    placeholder="Feedback"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                    />
                <select className={styles.option} onChange={(e)=> {setFeedbackType( e.target.value)}}>
                    <option value="2">Acerto</option>
                    <option value="3">Erro</option>
                </select>
                <button type="submit" style={{ backgroundColor: 'green', color: 'white' }}>Adicionar Feedback</button>
            </form>
            <div className={styles.lista}>
                {feedbacks && feedbacks.map((feedback) => (
                    <Feedback type={feedback.FK_feedback_type_id == '2'? 'acerto' : 'erro'}  feedback={feedback} deletarFeedback={deletarFeedback}/>
                ))}
            </div>
        </div>
                    </Board>
                    <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 
                    </div>
    );
};


